import type { TUploadParams } from '../types/TUploadParams';

export async function putToS3(arg: {
  file: File;
  params: TUploadParams;
  onProgress?: (p: number) => void;
  signal?: AbortSignal;
}) {
  const { file, params, onProgress, signal } = arg;
  if (params.method !== 'PUT') {
    throw new Error('Expected PUT signed URL');
  }
  return new Promise<{ serverId?: string }>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', params.url);
    if (params.headers) {
      Object.entries(params.headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    }
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress((e.loaded / e.total) * 100);
      }
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({});
        return;
      }
      reject(new Error(`S3 PUT failed ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('Network error during upload'));
    if (signal) {
      signal.addEventListener('abort', () => xhr.abort());
    }
    xhr.send(file);
  });
}
